export { getI18nRoute } from "./getI18nRoute";
